// import { CognitoUserPool } from 'amazon-cognito-identity-js';
// import Env from '../runtimeEnv';

// const poolData = {
    
//     UserPoolId: Env.REACT_APP_COGNITO_USER_POOL_ID, // Fetching from environment variable
//     ClientId: Env.REACT_APP_COGNITO_CLIENT_ID,      // Fetching from environment variable
// };

// export const userPool = new CognitoUserPool(poolData);


import { CognitoUserPool } from "amazon-cognito-identity-js";
import Env from "../runtimeEnv";

const poolData = {
  UserPoolId: Env.REACT_APP_COGNITO_USER_POOL_ID || "",
  ClientId: Env.REACT_APP_COGNITO_CLIENT_ID || "",
};

if (!poolData.UserPoolId || !poolData.ClientId) {
  console.error("UserPool.js: error event");
  throw new Error(
    "Both UserPoolId and ClientId are required. Check .env or runtime env setup."
  );
}

export const userPool = new CognitoUserPool(poolData);
